import React, { useState } from 'react';
import './FeaturedPanel.css';
import GreenPlazaModal from '../GreenPlazaModal/GreenPlazaModal';
import BrochureViewer from '../BrochureViewer/BrochureViewer';
import CertificateModal from '../CertificateModal/CertificateModal';

const featured = {
  name: 'Paradise Greens Plaza',
  address: 'Sector 16B, Near 1 Murti Chowk, Noida Extension',
  price: '₹23.09 Lacs*',
  hot: true,
  beds: 'Studio',
  baths: '—',
  area: '330–725 sq.ft',
  garage: 'Retail Shops',
  pool: 'Ready to Move',
  image: '/image/Greenparadise.jpg',
};

export default function FeaturedPanel() {
  const [liked, setLiked] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [certType, setCertType] = useState(null);

  const BROCHURE = '/brochure/PGP.pdf';

  const handleDownload = async (e) => {
    e.stopPropagation();
    try {
      const res = await fetch(BROCHURE);
      if (!res.ok) throw new Error('not ok');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = 'Paradise_Greens_Plaza_Brochure.pdf';
      document.body.appendChild(a); a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch {
      const a = document.createElement('a');
      a.href = BROCHURE; a.download = 'Paradise_Greens_Plaza_Brochure.pdf';
      a.click();
    }
  };

  return (
    <div className="featured-panel">

      {/* Featured Card — clickable */}
      <div
        className="featured-card fp-clickable"
        onClick={(e) => { if (!e.target.closest('.fp-actions')) setShowModal(true); }}
        style={{ cursor: 'pointer' }}
        title="Click to view full details"
      >
        {/* Hover hint */}
        <div className="fp-hint">
          <i className="fa fa-eye" /> View Full Details
        </div>

        <div className="card-img tall">
          <img src={featured.image} alt={featured.name} />
          <button
            className={`wishlist ${liked ? 'active' : ''}`}
            onClick={(e) => { e.stopPropagation(); setLiked(!liked); }}
            aria-label="Toggle wishlist"
          >
            <i className={liked ? 'fa-solid fa-heart' : 'fa-regular fa-heart'} />
          </button>
          {featured.hot && (
            <span className="badge hot">
              <i className="fa fa-fire" /> Hot price
            </span>
          )}
          <div className="img-dots">
            <span className="dot" />
            <span className="dot active" />
            <span className="dot" />
            <span className="dot" />
          </div>
        </div>

        <div className="featured-info">
          <div className="featured-top">
            <div>
              <div className="featured-name">{featured.name}</div>
              <div className="featured-addr">
                <i className="fa fa-location-dot" /> {featured.address}
              </div>
            </div>
            <div className="featured-right">
              <div className="featured-price">{featured.price}</div>
              {featured.hot && (
                <span className="badge-inline hot">
                  <i className="fa fa-fire" /> Hot price
                </span>
              )}
            </div>
          </div>
          <div className="featured-meta">
            <span><i className="fa fa-bed" /> {featured.beds}</span>
            <span><i className="fa fa-expand" /> {featured.area}</span>
            <span><i className="fa fa-store" /> {featured.garage}</span>
            <span><i className="fa fa-key" /> {featured.pool}</span>
          </div>

          {/* PDF & Certificate Actions */}
          <div className="fp-actions card-actions" onClick={(e) => e.stopPropagation()}>
            <button
              className="card-action-btn view-pdf-btn"
              onClick={() => setShowPdf(true)}
            >
              <i className="fa fa-eye" /> View PDF
            </button>
            <button
              className="card-action-btn download-btn"
              onClick={handleDownload}
            >
              <i className="fa fa-download" /> Download
            </button>
            <button
              className="card-action-btn booking-btn"
              onClick={() => setCertType('booking')}
            >
              <i className="fa fa-certificate" /> Booking
            </button>
            <button
              className="card-action-btn appt-btn"
              onClick={() => setCertType('appointment')}
            >
              <i className="fa fa-calendar-check" /> Appt.
            </button>
          </div>
        </div>
      </div>

      {/* Map */}
      <div className="map-box">
        <iframe
          title="Property Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.8!2d77.4389!3d28.635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sNoida%20Extension!5e0!3m2!1sen!2sin!4v1699999999999"
          width="100%"
          height="220"
          style={{ border: 0, borderRadius: '12px' }}
          allowFullScreen=""
          loading="lazy"
        />
        <div className="map-pin-badge">
          ₹23.09 Lacs* <i className="fa fa-location-dot" />
        </div>
      </div>

      {showModal && <GreenPlazaModal onClose={() => setShowModal(false)} />}
      {showPdf   && <BrochureViewer pdfUrl={BROCHURE} title="Paradise Greens Plaza" onClose={() => setShowPdf(false)} />}
      {certType  && <CertificateModal type={certType} project="Paradise Greens Plaza" onClose={() => setCertType(null)} />}
    </div>
  );
}
